(() => {
  if (window.__freeGiftProgressInit) return;
  window.__freeGiftProgressInit = true;
  const selector = '[data-free-gift-progress]';
  let refreshPending = false;

  const refreshProgress = () => {
    const elements = Array.from(document.querySelectorAll(selector));
    if (!elements.length) return;

    const sectionId = elements[0].dataset.sectionId;
    if (!sectionId) return;

    fetch(`?section_id=${encodeURIComponent(sectionId)}`)
      .then((response) => response.text())
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const updated = doc.querySelector(selector);

        elements.forEach((element) => {
          if (updated) {
            element.replaceWith(updated.cloneNode(true));
          } else {
            element.remove();
          }
        });
      })
      .catch(() => {});
  };

  const scheduleRefresh = () => {
    if (refreshPending) return;
    refreshPending = true;
    window.requestAnimationFrame(() => {
      refreshPending = false;
      refreshProgress();
    });
  };

  const bindEvents = () => {
    document.querySelectorAll('cart-form').forEach((cartForm) => {
      cartForm.addEventListener('cart-updated', scheduleRefresh);
    });

    document.querySelectorAll('product-form').forEach((form) => {
      form.addEventListener('add-to-cart', scheduleRefresh);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindEvents);
  } else {
    bindEvents();
  }
})();
